function openCartDrawer(){
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.classList.add('active');
}

let dataAddToCart = {'items':[]}

async function updateCartUI(){
    dataAddToCart['items'] = [];
    const res = await fetch('/?section_id=cart-drawer');
    const text = await res.text();
  
    const html = new DOMParser().parseFromString(text, 'text/html')
  
    const newBox = html.querySelector(".drawer").innerHTML;
    document.querySelector(".drawer").innerHTML = newBox;
}

async function addToCart(dataAddToCart) {
    console.log(dataAddToCart);
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataAddToCart)
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const cart = await response.json();

        await updateCartUI();
        window.refreshSlider();

    } catch (error) {
        console.error("Impossible d'ajouter le produit au panier", error);
    }
}